















































import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesUpdownIos'
})
export default class extends Vue {}
